import { render, staticRenderFns } from "./art.vue?vue&type=template&id=3162bf70&scoped=true&"
import script from "./art.vue?vue&type=script&lang=js&"
export * from "./art.vue?vue&type=script&lang=js&"
import style0 from "./art.vue?vue&type=style&index=0&id=3162bf70&prod&lang=scss&scoped=true&"
import style1 from "./art.vue?vue&type=style&index=1&id=3162bf70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3162bf70",
  null
  
)

export default component.exports